import axios from 'axios'

import { BASE_URL } from '@/api/api.constants'

type LoginParams = {
  username: string
  password: string
}

const LOGIN_PATH = '/login'
const LOGOUT_PATH = '/logout'

export const login = async ({
  username,
  password,
}: LoginParams): Promise<{ token: string; regions: any }> => {
  const response = await axios.post(`${BASE_URL}${LOGIN_PATH}/`, {
    username,
    password,
  })

  if (!response.data.token) {
    throw new Error('Authentication failed: No token received')
  }
  sessionStorage.setItem('token', response.data.token)

  const regions = await axios.get(`${BASE_URL}/regions/`, {
    headers: {
      Authorization: `Bearer ${response.data.token}`,
    },
  })

  if (!regions.data) {
    throw new Error('Failed to fetch regions. Please login again.')
  }
  sessionStorage.setItem('regions', JSON.stringify(regions.data))

  return {
    token: response.data.token,
    regions: regions.data,
  }
}

export const logout = async (): Promise<void> => {
  await axios.post(`${BASE_URL}${LOGOUT_PATH}/`, {})
}
